import { useState } from 'react';
import { useAuth } from 'context/AuthContext';
import DeleteIcon from 'icons/DeleteIcon';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import DeleteCasesDialog from '../DeleteCasesDialog/DeleteCasesDialog';

interface Props {
  ids: number[];
  refetch?: () => void;
}

export default function DeleteCasesButton({ ids, refetch }: Props) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <>
      <CustomButton
        text='Delete'
        variant='outlined'
        intent='error'
        color='error'
        onClick={() => setOpen(true)}
        height={40}
        startIcon={<DeleteIcon size={14} />}
      />

      <DeleteCasesDialog
        open={open}
        setOpen={setOpen}
        userId={user.id}
        procedureIds={ids}
        refetch={refetch}
      />
    </>
  );
}
